import { render } from "./Label.vue?vue&type=template&id=2477c96a"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"

import exportComponent from "E:\\server\\www\\kpowa-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__